import { useMutation } from '@apollo/client';
import gql from 'graphql-tag';

import type { CreateAdminUserFilterRequest } from '@coursera/grpc-types-entsavedfilters/coursera/proto/entsavedfilters/v1beta1/enterprise_saved_filters_api';

import type { SavedAdminFilter } from './types';
import { mapUserFilterFromClientToServerModel } from './utils';

export const createAdminUserFilterMutation = gql`
  mutation CreateAdminUserFilterMutation($input: CreateAdminUserFilterRequest!) {
    CreateAdminUserFilterMutation(input: $input)
      @rest(
        type: "CreateAdminUserFilter"
        path: "grpc/entsavedfilters/v1beta1/EnterpriseSavedFiltersAPI/CreateAdminUserFilter"
        method: "POST"
      ) {
      adminUserFilter
    }
  }
`;

export type CreateAdminUserFilterMutation = {
  createAdminUserFilter: (request: {
    variables: {
      input: CreateAdminUserFilterRequest;
    };
  }) => Promise<{
    data?: {
      CreateAdminUserFilterMutation: {
        adminUserFilter: { filterId: string };
      };
    } | null;
  }>;
};

export const useCreateAdminUserFilterMutation = () => {
  const [createAdminUserFilter] = useMutation<
    {
      CreateAdminUserFilterMutation: {
        adminUserFilter: { filterId: string };
      };
    },
    {
      input: CreateAdminUserFilterRequest;
    }
  >(createAdminUserFilterMutation);

  return createAdminUserFilter;
};

export const useCreateAdminUserFilter = (org: { id: string }) => {
  const createAdminUserFilter = useCreateAdminUserFilterMutation();
  return async (searchNameOrEmails: string, savedFilter?: SavedAdminFilter, filterPurpose = 'FILTER_PURPOSE_REUSE') => {
    const filter =
      savedFilter &&
      mapUserFilterFromClientToServerModel(savedFilter.filter, {
        searchNameOrEmails: searchNameOrEmails ? [searchNameOrEmails] : undefined,
      });

    const input = {
      organizationId: org.id,
      filterName: '',
      filterPurpose,
      filter,
    };
    const response = await createAdminUserFilter({ variables: { input } });
    return response.data?.CreateAdminUserFilterMutation.adminUserFilter.filterId;
  };
};
